import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border: 1px solid #ccc;
  padding: ${props => props.theme.spacing()}px;
`;
